import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from './themeShared';

const helpers = createMultiStyleConfigHelpers(['field']);

export const baseStyle = (theme: ThemesKeys) => ({
  field: {
    borderRadius: getThemes(theme).radii.lg,
    boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.primary[80]}`,
    bg: 'white',
    _focusVisible: {
      boxShadow: `0 0 0 2px ${getThemes(theme).colors.palette.primary[50]}`,
    },
    _disabled: {
      backgroundColor: 'white',
      opacity: 1,
      color: getThemes(theme).colors.palette.text.secondary[80],
      boxShadow: `0 0 0 1px ${getThemes(theme).colors.palette.stroke.secondary[90]} !important`,
    },
  },
});

export const sm = (theme: ThemesKeys) => ({
  field: {
    height: '32px',
    fontSize: getThemes(theme).fontSizes.sm,
    paddingX: '8px',
  },
});

export const md = (theme: ThemesKeys) => ({
  field: {
    height: '40px',
    fontSize: getThemes(theme).fontSizes.md,
    paddingX: '12px',
  },
});

export const lg = (theme: ThemesKeys) => ({
  field: {
    height: '48px',
    fontSize: getThemes(theme).fontSizes.lg,
    paddingX: '16px',
  },
});

export const sizes = (theme: ThemesKeys) => ({
  sm: sm(theme),
  md: md(theme),
  lg: lg(theme),
});

export const TimePickerTheme = (theme: ThemesKeys) =>
  helpers.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    sizes: sizes(theme),
  });

export default TimePickerTheme;
